import * as React from "react";
import { cva } from "class-variance-authority";
import { Checkbox as CheckboxPrimitive } from "radix-ui";

import { cn } from "@/lib/cn";
import { CheckIcon } from "@radix-ui/react-icons";

const checkboxVariants = cva(
  // after:-inset-1 gives the 16px box a 24px hit area for WCAG 2.5.8
  "shadow-sm peer relative size-4 shrink-0 rounded-sm border border-input after:absolute after:-inset-1 hover:border-foreground/60 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
  {
    variants: {
      hasError: {
        true: "border-destructive focus-visible:outline-destructive",
        false: "",
      },
    },
    defaultVariants: {
      hasError: false,
    },
  },
);

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root ref={ref} className={cn(checkboxVariants({ className }))} {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <CheckIcon className="h-3.5 w-4" aria-hidden="true" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
